import React from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { hasAutopay } from "../atoms/atoms";
import { useRecoilState } from "recoil";

export const AutopayDetails: React.FC = () => {
  const formMethods = useFormContext();
  const [, sethasAutopay] = useRecoilState(hasAutopay);

  const handleInputChange = (event) => {
    const value = event.target.value.trim();
    if (value !== "") {
      sethasAutopay(true);
    } else {
      sethasAutopay(false);
    }
  };

  return (
    <>
      <div className="bg-bgDB mr-3 pb-1">
        <div className="bg-white box-shadow rounded-lg h-full">
          <div className="grid grid-cols-1 md:grid-cols-3 mx-3 my-3 gap-2 gap-x-2 py-2">
            <div className="space-y-1 mr-6">
              <TextInputLabelHookForm
                name="autoPayName"
                label="AutoPay Name"
                type="text"
                onChange={(e) => {
                  handleInputChange(e);
                }}
                className={
                  formMethods.formState.errors.autoPayName &&
                  formMethods.formState.errors.autoPayName.message &&
                  "border-2 border-red-500"
                }
                register={formMethods.register("autoPayName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={150}
              />
            </div>
            {/* <div className="space-y-1 mr-6">
              <TextInputLabelHookForm
                name="description"
                label="Description"
                type="text"
                className={
                  formMethods.formState.errors.description &&
                  formMethods.formState.errors.description.message &&
                  "border-2 border-red-500"
                }
                register={formMethods.register("description")}
                maxLength={150}
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AutopayDetails;
